export default {
  props: {
    type: {
      type: String,
      validator(value) {
        return ['success', 'error', 'warning', 'info'].indexOf(value) !== -1;
      },
      required: true,
    },
    layout: {
      type: String,
      validator(value) {
        return ['banner', 'inline'].indexOf(value) !== -1;
      },
      default: 'banner',
    },
    title: {
      type: String,
    },
    isDismissible: {
      type: Boolean,
      default: false,
    },
  },
};
